import { render, staticRenderFns } from "./AnnualReviews.vue?vue&type=template&id=81f0abd0&scoped=true"
import script from "./AnnualReviews.vue?vue&type=script&lang=js"
export * from "./AnnualReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f0abd0",
  null
  
)

export default component.exports